import { render, staticRenderFns } from "./icon-warp.vue?vue&type=template&id=d10631c2"
import script from "./icon-warp.vue?vue&type=script&lang=js"
export * from "./icon-warp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports